import React from "react";
import { useVSETHContext } from "../VSETHContext/VSETHContext";
interface Props
  extends React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {
  size?: number | string;
  variant?: "logo-mono" | "logo" | "signet-mono" | "signet";
  format?: "svg" | "png";
}
export const Logo: React.FC<Props> = ({
  size = 32,
  variant = "logo",
  format = "svg",
  ...imgProps
}) => {
  const { globID, static_url } = useVSETHContext();
  return (
    <img
      height={size}
      src={`${static_url}/assets/${globID}/${variant}.${format}`}
      {...imgProps}
    />
  );
};
